// CANONICAL COPY (GH #7115). src/constants/obligations/obl-cabling-security.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-cabling-security',
  title: 'Verify cabling security',
  description:
    'Confirm that cables carrying power, data or supporting information services are protected from interception, interference or damage. Controls shall include routing cables underground or through conduit where feasible, separating power and communications cables, armoured conduit or locked cabinets for sensitive cabling, tamper-evident inspection points for high-sensitivity runs, and clear labelling to prevent accidental disconnection. Review cable-management standard and inspection records for critical cable runs.',
  category: 'assets',
  scfIds: ['SCF-PHY-012'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Cabling security standard is published' },
    { type: 'document-within-sla', description: 'Standard review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
